
































import './KisweDraggableItem.scss'
import { defineComponent, Ref, ref } from '@vue/composition-api'
import { Drag, Drop } from 'vue-drag-drop'
import { KisweIcon } from '@/modules/kisweui/components'
import { ItemDragData } from '../../types'

export default defineComponent({
  name: 'KisweDraggableItem',
  components: {
    Drag,
    Drop,
    KisweIcon
  },
  props: {
    isDragEnabled: {
      type: Boolean,
      required: false,
      default: true
    },
    dragItemId: {
      type: String as () => string,
      required: true
    },
    showIconOnHover: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: {
    itemDragged (dragData: ItemDragData) { return !!dragData.fromItemId && !!dragData.toItemId }
  },
  setup () {
    const isDragOverItem: Ref<boolean> = ref(false)

    return {
      isDragOverItem
    }
  },
  methods: {
    async dropItem (data: ItemDragData, _nativeEvent: DragEvent) {
      this.isDragOverItem = false
      data.toItemId = this.dragItemId
      this.$emit('itemDragged', data)
    },
    getDragData (): ItemDragData {
      return { fromItemId: this.dragItemId, toItemId: null }
    },
    dragEnter (_data: ItemDragData, _nativeEvent: DragEvent) {
      this.isDragOverItem = true
    },
    dragLeave (_data: ItemDragData, _nativeEvent: DragEvent) {
      this.isDragOverItem = false
    }
  }
})
